import React, { useEffect, useRef, useState } from 'react';
import { Terminal } from 'xterm';
import { FitAddon } from 'xterm-addon-fit';
import { WebLinksAddon } from 'xterm-addon-web-links';
import { SearchAddon } from 'xterm-addon-search';
import { Unicode11Addon } from 'xterm-addon-unicode11';
import socketIOClient from 'socket.io-client';
// import { AttachAddon } from 'xterm-addon-attach';
import 'xterm/css/xterm.css';
import SpinnerCircles from '../Spinner/SpinerCircles';
import { dataCenterShellUrls } from '../EpikBoxes/BoxOverview';
import { useSelector } from 'react-redux';

function MyTerminal({ vpnAddress, usb, twoFaId, usbSpeed, sessionEnd, onCloseClick }) {
  const token = localStorage.getItem('jwtToken')
  const box = useSelector(state => state.AppState.boxDetails.box)
  const user = useSelector(state => state.AppState.user)
  const [socket, setSocket] = useState();
  const terminalRef = useRef(null);
  const terminal = useRef(null);
  const fitAddon = useRef(null);
  const webLinksAddon = useRef(null);
  const searchAddon = useRef(null);
  const unicode11Addon = useRef(null);
  // const attachAddon = useRef(null);

  const isConnected = useRef(false);
  const [loading, setLoading] = useState(true);
  const [loadingMsg, setLoadingMsg] = useState('');

  useEffect(() => {
    console.log('my terminal')

    if (!terminal.current) {
      // let current = new Terminal({
      //   allowProposedApi: true
      // });

      // const socket = socketIOClient.connect('http://localhost:8000');
      // const socket = socketIOClient.connect('http://10.254.254.63:8000');
      let url = dataCenterShellUrls[box.datacenter];
      const socket = socketIOClient.connect(url, { query: { token } });
      console.log('CONNECTION SOCKET');
      socket.on('connect', () => {
        setSocket(socket);
        console.log('Successfully connected!');
        socket.emit('PTY', {
          vpnAddress: vpnAddress,
          usb,
          twoFaId,
          usbSpeed,
          userId: user._id
        });
      });

      socket.on(`pty-${vpnAddress}-connection`, (data) => {
        console.log('ssh data ', data);
        setLoadingMsg(data.process);
        if (data.process === 'completed') {
          console.log('ssh completed ', data);

          isConnected.current = true;
          setTimeout(()=>{
            initTerminal(socket);
          },1000)
          
          setLoading(false);
        }
      });
    }
    return () => {
      if (socket) {
        socket.off(`pty-${vpnAddress}-connection`);
        socket.off(`pty-${vpnAddress}-response`)
        socket.close()
      }
    }
  }, [vpnAddress]);

  const initTerminal = (socket) => {
    terminal.current = new Terminal({
      allowProposedApi: true,
      cursorBlink: true
    });
    fitAddon.current = new FitAddon();
    webLinksAddon.current = new WebLinksAddon();
    searchAddon.current = new SearchAddon();
    unicode11Addon.current = new Unicode11Addon();
    // attachAddon.current = new AttachAddon(new WebSocket('ws://localhost:3001'));

    terminal.current.loadAddon(fitAddon.current);
    terminal.current.loadAddon(webLinksAddon.current);
    terminal.current.loadAddon(searchAddon.current);
    terminal.current.loadAddon(unicode11Addon.current);
    // terminal.current.loadAddon(attachAddon.current);
    // current.on
    terminal.current.onData(data => {
      socket.emit('PTY', {
        vpnAddress,
        'command': data,
        usb,
        twoFaId,
        usbSpeed
      });
    });

    if (isConnected.current) {
      socket.on(`pty-${vpnAddress}-response`, data => {
        console.log({ remoteData: data });
        terminal.current.write(data.data);
      });

    }

    terminal.current.open(terminalRef.current);
    fitAddon.current.fit();

    socket.on(`pty-${vpnAddress}-disconnect`, data => {
      console.log('socket off')
      socket.off(`pty-${vpnAddress}-connection`);
      socket.off(`pty-${vpnAddress}-response`)
      socket.close()
      onCloseClick()
    })
  };

  return <div className='custom-terminal'>{
    loading ? <div className='custom-spinner-container'>
      <SpinnerCircles red /><span>{loadingMsg}</span></div> :
      <div>
        <div ref={terminalRef} style={{ width: '100%', height: '100%' }} />
      </div>}
  </div>;
}

export default MyTerminal;
